module.exports = __webpack_public_path__ + "en_GB-download-a0e859.webp";